<mat-dialog-content class="modal-content">
    <div class="scrollable-container"  >
        <div class="modal-body">
            <h1>POLÍTICA DE PRIVACIDAD</h1>
            <h2>METROGAS S.A.</h2>
            <h3>I. Objetivos y aplicación de la Política de Privacidad</h3>
            <p>Metrogas S.A. (en adelante denominada “Metrogas”) está comprometida con el resguardo y
                protección de los datos de carácter personal de sus clientes. Por ello Metrogas ha implementado
                esta política de privacidad orientada a proteger esta información de carácter personal y dar
                cumplimiento a la normativa vigente. Esta política se aplica a los datos personales de los Titulares y
                los usuarios de las distintas herramientas y canales dispuestos para proveer los Servicios.
            </p>
            <p>
                Esta política sólo aplica a los datos personales que son tratados por Metrogas o por mandatarios
                específicamente autorizados por esta, y no regula el tratamiento que terceros realizan a través de
                otras aplicaciones, sitios de internet, aun cuando estos estén enlazados al sitio web o aplicación
                móvil de Metrogas. En tal caso, se deberá estar a lo que prescriba la política de privacidad de dichas
                aplicaciones, sitios y/o redes sociales.
            </p>

            <h3>II. Responsable del tratamiento de datos</h3>
            <p>Metrogas S.A.<br>
                RUT 96.722.460-K<br>
                Representantes legales: Sebastián Bernstein Llona y Elena Warnken Poblete.<br>
                Domicilio: El Regidor 54, comuna de Las Condes, Santiago, Chile.<br>
                Correo electrónico de contacto: privacidad@metrogas.cl
            </p>


            <h3>III. Marco legal</h3>
            <ol>
                <li>Artículo 19 N°4 de la Constitución Política de la República de Chile.</li>
                <li>Ley 19.628 sobre protección a la vida privada.</li>
                <li>Artículo 15 bis de la Ley 19.496 que establece normas sobre protección de los derechos de los consumidores.</li>
            </ol>

            <h3>IV. Definiciones</h3>
            <p>Para los efectos de esta política, los términos en mayúsculas o minúsculas, según sea el caso, tendrán los significados que se especifican en el siguiente listado:</p>
            <ol>
                <li><strong>“Datos personales”</strong> o <strong>“datos personales”</strong>: Cualquier información vinculada o referida a una persona natural, identificada o identificable.</li>
                <li><strong>“Datos personales sensibles”</strong> o <strong>“datos sensibles”</strong>: Aquellos datos que se refieren a las características físicas o morales de las personas o a hechos o circunstancias de su vida privada o intimidad, tales como hábitos personales, el origen racial, las ideologías, creencias, opiniones políticas y la vida sexual.</li>
                <li><strong>“Empresas Relacionadas”</strong>: respecto del Responsable, tendrá el significado establecido en el artículo 100 de la ley 18.045 de mercado de valores.</li>
                <li><strong>“Encargado del tratamiento de datos”</strong> o <strong>“Encargado”</strong>: Persona natural o jurídica que trata los datos personales por cuenta del Responsable.</li>
                <li><strong>“Responsable del tratamiento”</strong> o <strong>“Responsable”</strong>: Es la persona natural o jurídica, privada o pública, que decide sobre el tratamiento de los datos, es decir, quien toma decisiones sobre qué hacer con los mismos desde su captura hasta la eliminación de estos. Para los efectos de la presente política de privacidad, Metrogas actúa como Responsable del tratamiento.</li>
                <li><strong>“Servicios”</strong>: Todas aquellas prestaciones que Metrogas provee por sí o a través de las Empresas Relacionadas o de terceros.</li>
                <li><strong>“Titular de datos personales”</strong> o <strong>“Titular”</strong>: Persona natural cuyos datos personales son objeto de tratamiento y del que Metrogas es Responsable.</li>
                <li><strong>“Transferencia de datos”</strong>: tiene lugar cuando el Responsable y/o Encargado del tratamiento de datos personales, ubicado en Chile, envía la información o los datos personales a un receptor, que a su vez es responsable (según corresponda) del tratamiento y se encuentra dentro o fuera del país.</li>
                <li><strong>“Transmisión de datos”</strong>: tratamiento de datos personales que implica la comunicación de estos dentro o fuera del territorio del país cuando tenga por objeto la realización de un tratamiento por el Encargado, por cuenta del Responsable.</li>
                <li><strong>“Tratamiento de datos”</strong> o <strong>“tratamiento”</strong>: Cualquier operación o complejo de operaciones o procedimientos técnicos, de carácter automatizado o no, que permitan recolectar, almacenar, grabar, organizar, elaborar, seleccionar, extraer, confrontar, interconectar, disociar, comunicar, ceder, transferir, transmitir o cancelar datos de carácter personal, o utilizarlos en cualquier otra forma.</li>
            </ol>

            <h3>V. Base de licitud del tratamiento de datos</h3>
            <p>
                El tratamiento de datos personales que realiza Metrogas se funda en el consentimiento expreso e
                informado del Titular y/o en la ley.
            </p>

            <h3>VI. Datos personales recolectados</h3>
            <p>Los siguientes datos podrán ser recolectados por Metrogas:</p>
            <ol>
                <li>
                    Identificadores personales y datos demográficos como nombre, apellido, Rol Único
                    Nacional, Rol Único Tributario, número de documento de identidad, domicilio, dirección de
                    correo electrónico, número de teléfono, edad, nacionalidad, fecha de nacimiento y cédula
                    de identidad.
                </li>
                <li>
                    Datos sensibles tales como: (a) género; (b) hábitos personales (incluido los datos de
                    consumo de gas); (c) datos biométricos, (d) características físicas tales como imágenes
                    faciales o del rostro.
                </li>
                <li>
                    Datos para la evaluación de factibilidad de los Servicios, como artefactos disponibles en el
                    hogar, características del inmueble, instalaciones, consumo de gas, relación jurídica del
                    Titular con el domicilio y los documentos que acreditan dicha relación, personerías o
                    documentos que acrediten la representación legal en caso de que el cliente de Metrogas sea
                    una persona jurídica, composición o situación familiar.
                </li>
                <li>
                    Medios de pagos utilizados, datos relacionados con su información y tarjetas bancarias.</li>
                <li>
                    Información comercial, incluidas las compras y boletas o facturas asociadas a los Servicios,
                    así como información de experiencia o satisfacción del Titular al utilizar los Servicios.
                </li>
                <li>
                    Información sobre su actividad en Internet o en redes similares (incluidas las interacciones
                    con el sitio web y otras herramientas tecnológicas utilizadas o que a futuro se utilicen por
                    Metrogas), cookies, datos del dispositivo (como el ID del dispositivo, el fabricante, el sistema
                    operativo, el idioma), dirección IP y el historial de navegación, búsqueda y compras
                    efectuadas en el sitio web y de los Servicios que este provee personalmente o por medio de
                    proveedores.
                </li>
                <li>Datos de fuentes de acceso público.</li>
            </ol>

            <p> 
                Se hace presente que estos datos personales pueden ser directamente proporcionados por los
                Titulares o recolectados de fuentes accesibles al público mediante el uso de cookies o tecnologías
                similares (para mayor información puedes revisar lo señalado en el capítulo siguiente).
            </p>

            <h3>VII. Recolección de datos personales</h3>
            <p> 
                Metrogas podrá recolectar datos personales por diferentes medios tales como la contratación y uso
                de los Servicios, formularios físicos y/o digitales, llamadas telefónicas, videollamadas, fotografías o
                imágenes, actividades, concursos, eventos, canales de reclamos/denuncias, correos electrónicos,
                mensajes de textos (SMS), mensajería instantánea (por ejemplo, WhatsApp o Telegram), atención
                dada por servicio de atención a clientes (soporte), redes sociales, atención en línea, fuentes
                accesibles al público, información entregada por autoridades públicas, datos personales
                proporcionados directamente por los Titulares, entre otros.
            </p>


            <h3>VIII. Finalidades del tratamiento</h3>
            <p>Metrogas tratará los datos personales y datos sensibles con los siguientes propósitos:</p>
            <ol>
                <li>Para satisfacer o cumplir el motivo por el cual nos proporcionó la información, tales como dar respuesta a los requerimientos del Titular y otros relacionados con los Servicios proveídos por Metrogas.</li>
                <li>Para proveer el servicio de suministro de gas y productos y servicios afines o complementarios.</li>
                <li>Para permitir que Metrogas pueda dar cumplimiento a sus obligaciones legales.</li>
                <li>Realizar todas las gestiones necesarias para confirmar la información personal del Titular y para la seguridad de esta información, tales como analizar los datos del perfil del Titular y de cualquier otra naturaleza, tales como hábitos personales, datos demográficos, ubicaciones geográficas y/o datos de contacto.</li>
                <li>Con fines comerciales, con el objeto de promocionar y ofrecer los productos y Servicios proveídos por Empresas Relacionadas o por terceros relacionados en virtud de programas de fidelización, informar acerca de nuevos productos, promociones, descuentos y ofertas, encuestas, entre otros.</li>
                <li>Para verificar la información de la relación jurídica que el Titular mantiene con el domicilio y con Metrogas, y para realizar la cobranza de los productos y servicios.</li>
                <li>Para controlar, prevenir y detectar fraudes y otras actividades ilícitas.</li>
                <li>Para facilitar el acceso de los Titulares al portal web y la administración del mismo.</li>
                <li>Para cumplir con las políticas internas de Metrogas y con las normas de calidad y seguridad que sean aplicables.</li>
            </ol>


            <h3> IX. Comunicación de datos</h3>
            <p> 
                Metrogas no compartirá los datos personales del Titular con terceros, salvo que exista un mandato
                legal que lo permita y en aquellos casos que el Titular expresamente consienta en ello.
            </p>
            <p>
                Mediante la aceptación de la presente política de privacidad, el Titular autoriza expresamente a
                Metrogas a comunicar (ya sea como Transferencia o como Transmisión de datos) sus datos
                personales en las siguientes situaciones:
            </p>

            <ol>
                <li>
                    Con terceros proveedores de productos y servicios que se encuentren relacionados
                    exclusivamente con la prestación de Servicios que provee Metrogas o de servicios afines a
                    los Servicios que son provistos por dichos terceros. Tales proveedores acceden a datos
                    personales en calidad de Encargados del Tratamiento, esto es, tratan sus datos por cuenta
                    de Metrogas. Al respecto, Metrogas ha adoptado criterios de selección de proveedores
                    destinados a que estos presten sus Servicios dando cumplimiento a las políticas de
                    protección de datos definidas por esta, tanto en materias de confidencialidad, como de
                    resguardo de la información.
                </li>
                <li>
                    En cumplimiento del numeral Octavo anterior, Metrogas podrá comunicar sus datos de
                    contacto para que las Empresas Relacionadas puedan promocionar y ofertar sus productos
                    y Servicios.
                </li>
                <li>
                    Para contribuir en la prevención de un fraude u otros delitos, o para hacer cumplir o proteger
                    los derechos y propiedades del Titular y de Metrogas. Se incluye la comunicación para este
                    fin entre las Empresas Relacionadas.
                </li>
                <li>
                    Para proteger la seguridad personal de los empleados de Metrogas, de clientes, del Titular
                    y en general toda persona.
                </li>
                <li>
                    Con el Registro Civil e Identificación u otras empresas u organizaciones que estén facultadas
                    legalmente para realizar servicios de validación de identidad, en caso de que sea necesario
                    autentificar y validar la identidad de los Titulares al momento del uso de los Servicios.
                </li>
                <li>
                    Para el caso de producirse una circunstancia en que, por motivos estratégicos u otros
                    motivos comerciales, Metrogas decidiera vender, comprar, fusionarse o reorganizar sus
                    negocios de otra forma. En tal caso, dicha transacción podría incluir la divulgación de
                    información personal a compradores reales. No obstante, Metrogas, adoptará las medidas
                    correspondientes destinadas a proteger adecuadamente la información personal en este
                    tipo de transacciones, con la finalidad de que el destinatario de dicha información respete
                    la autorización de tratamiento de datos en los términos otorgados en su origen y además
                    mantenga los deberes de custodia y conservación de la información en los términos
                    establecidos por la ley.
                </li>

                <p> 
                    En todos estos casos, quien resulte como Encargado del tratamiento de datos deberá dar
                    cumplimiento a la presente política de privacidad, especialmente a lo dispuesto respecto de las
                    finalidades del tratamiento de datos personales establecido en el numeral Octavo anterior.
                </p>
                <p>
                    Asimismo, Metrogas podrá comunicar sus datos personales con las autoridades que corresponda en
                    caso de reclamos o emergencias, como por ejemplo a la Superintendencia de Electricidad y
                    Combustibles, Carabineros de Chile, Cuerpos de Bomberos o cualesquiera otras relacionadas con la
                    atención de casos de similar naturaleza. En estos casos no se requerirá del consentimiento del
                    Titular, sino que la ley será el fundamento para tratar sus datos personales.
                </p>
            </ol>

            <h3>X. Tratamiento de datos realizado por terceros fuera de Chile</h3>
            <p>
                Mediante la aceptación de esta política de privacidad, el Titular autoriza expresamente a Metrogas
                para comunicar sus datos personales a servidores ubicados en la nube y/o en territorio extranjero.
            </p>

            <h3>XI. Medidas de seguridad para el tratamiento de datos personales.</h3>
            <p>
                Metrogas implementa medidas de seguridad administrativas, técnicas y organizativas para proteger
                los datos personales de los Titulares contra daño, pérdida, alteración, destrucción o el uso, acceso o
                tratamiento no autorizado, entre otros. Asimismo, se exigen estas mismas medidas de seguridad a
                los proveedores de servicios.
            </p>

            <h3>XII. Vigencia del tratamiento de datos</h3>
            <p>
                Los datos personales de los Titulares regulados en la presente política serán tratados durante el
                tiempo que sea necesario para el cumplimiento de las finalidades antes indicadas, salvo que por
                disposiciones legales o regulatorias deba darse cumplimiento a un plazo legal que van más allá de
                este término, en cuyo caso se mantendrán por el periodo que indica la norma.
            </p>

            <h3>XIII. Derechos del Titular de los datos personales</h3>
            <p>
                Los Titulares de datos personales cuentan con los siguientes derechos:
            </p>
            <ol>
                <li>
                    Acceso: el Titular de datos personales podrá solicitar a Metrogas información acerca de si
                    sus datos personales están siendo tratados por esta y, en su caso, acceder a ellos.
                </li>
                <li>
                    Rectificación: el Titular de datos personales podrá solicitar a Metrogas que modifique o
                    enmiende sus datos personales, cuando sean inexactos, desactualizados, incompletos o
                    induzcan a error.
                </li>
                <li>
                    Oposición: significa la facultad del Titular de datos personales para solicitar a Metrogas que
                    no se lleve a cabo un tratamiento de datos determinado.
                </li>
                <li>
                    Cancelación: el Titular de datos personales podrá solicitar a Metrogas que suprima o elimine
                    sus datos personales cuando se haya revocado el consentimiento para su tratamiento y no
                    exista una base de licitud para el tratamiento, cuando el tratamiento resulte ilícito, o bien
                    cuando los datos estén caducos.
                </li>
            </ol>

            <p>
                Los Titulares podrán ejercer estos derechos sin costo alguno, para lo cual deberán enviarnos una
                solicitud al correo electrónico privacidad@metrogas.cl, la cual deberá contener, al menos, los
                siguientes elementos:
            </p>
            <ol>
                <li>
                    El nombre y apellidos del Titular de los datos personales o de su representante legal o
                    mandatario, según corresponda.
                </li>
                <li>
                    En caso de representación, la solicitud deberá indicar el nombre, apellido y cédula de
                    identidad del representante del Titular de los datos personales, a la que adjuntará una copia
                    de este y el documento en el que conste el poder del representante con facultades expresas
                    para el ejercicio del derecho respectivo (carta poder con firma legalizada ante notario).
                </li>
                <li>
                    Cédula de identidad válida para los Titulares de datos chilenos o extranjeros con residencia
                    en el país. En caso de extranjeros sin residencia en Chile, pasaporte vigente.
                </li>
                <li>Casilla de correo electrónico o domicilio, para efectos de las notificaciones.</li>
                <li>
                    Identificación de los datos personales o del tratamiento determinado, respecto de los cuales
                    se ejerce el derecho correspondiente, detallando su solicitud.
                </li>
                <li>
                    En las solicitudes de rectificación de datos personales, el solicitante/Titular deberá indicar
                    las modificaciones o actualizaciones precisas a realizar y acompañar, en su caso los
                    antecedentes que las sustenten.
                </li>
                <li>
                    Cualquier otro documento o antecedente que el Titular desee adjuntar y que ayude a ubicar
                    los datos personales solicitados, así como información sobre otros medios de contacto,
                    como número telefónico, que facilite la tramitación de la solicitud de ejercicio sus derechos
                </li>
                <li>
                    Tratándose de menores de edad, el ejercicio de los derechos deberá ser realizado por el
                    padre, madre o tutor, lo cual deberá acreditarse mediante el documento legal que establezca
                    la calidad de padre, madre o tutor y con el respectivo documento que acredite su identidad
                    conforme al número 3 anterior.
                </li>
                <li>Fecha y firma del solicitante/Titular de datos personales.</li>
            </ol>

            <p>Metrogas podrá negar el ejercicio de los derechos al Titular en los siguientes casos:</p>

            <ol>
                <li>
                    Si el solicitante no es el Titular de los datos personales, o el representante legal no se
                    encuentra debidamente acreditado para ello.
                </li>
                <li>Si en las bases de datos de Metrogas no se encuentran los datos personales del solicitante.</li>
                <li>
                    Si existe un impedimento legal, o una resolución judicial o administrativa que restrinja el
                    ejercicio de los derechos al Titular de estos.
                </li>
                <li>
                    Cuando el Titular de los datos personales ya ejerció alguno de sus derechos y pretende
                    ejercerlos nuevamente sin haber transcurrido el plazo que tiene Metrogas para resolver su
                    solicitud.
                </li>
            </ol>
            <p>
                En caso de tener cualquier duda sobre los derechos antes mencionados, puede ponerse en contacto
                con nosotros al correo electrónico privacidad@metrogas.cl.
            </p>

            <h3>XIV. Contacto</h3>
            <p>
                Para cualquier duda respecto de los términos de la presente política de privacidad o el ejercicio de
                los derechos que la ley le confiere al Titular de los datos personales, usted podrá escribir a
                privacidad@metrogas.cl.
            </p>

            <h3>XV. Modificaciones a la presente política</h3>
            <p>
                Metrogas podrá modificar esta política de privacidad en cualquier momento, lo cual será notificado
                en los sitios web, aplicaciones y otros canales que se definan, solicitando al Titular la
                correspondiente autorización expresa de las nuevas condiciones.
            </p>
            <h3>XVI. Vigencia de la política</h3>
            <p>La presente Política comienza a regir con fecha 14 de febrero de 2024.</p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="btn btn-continuar center" (click)="onClose()">Aceptar</button>
</mat-dialog-actions>